/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimedDomainResponse
 */
export interface ClaimedDomainResponse {
    /**
     * Unique identifier for the claimed domain
     * @type {string}
     * @memberof ClaimedDomainResponse
     */
    id: string;
    /**
     * Type of the parent entity that claimed the domain
     * @type {string}
     * @memberof ClaimedDomainResponse
     */
    parentType: string;
    /**
     * ID of the parent entity that claimed the domain
     * @type {string}
     * @memberof ClaimedDomainResponse
     */
    parentId: string;
    /**
     * The normalized domain name
     * @type {string}
     * @memberof ClaimedDomainResponse
     */
    domain: string;
}

/**
 * Check if a given object implements the ClaimedDomainResponse interface.
 */
export function instanceOfClaimedDomainResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "parentType" in value;
    isInstance = isInstance && "parentId" in value;
    isInstance = isInstance && "domain" in value;

    return isInstance;
}

export function ClaimedDomainResponseFromJSON(json: any): ClaimedDomainResponse {
    return ClaimedDomainResponseFromJSONTyped(json, false);
}

export function ClaimedDomainResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimedDomainResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'parentType': json['parentType'],
        'parentId': json['parentId'],
        'domain': json['domain'],
    };
}

export function ClaimedDomainResponseToJSON(value?: ClaimedDomainResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'parentType': value.parentType,
        'parentId': value.parentId,
        'domain': value.domain,
    };
}

